import { render, staticRenderFns } from "./Recycling.vue?vue&type=template&id=633f7d1e"
import script from "./Recycling.vue?vue&type=script&setup=true&lang=js"
export * from "./Recycling.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports